import defaultImage from '@/assets/images/default.png'

const VARIANT_FALLBACKS = {
  small: ['small', 'mid', 'default', 'large'],
  mid: ['mid', 'small', 'default', 'large'],
  default: ['default', 'large', 'mid', 'small'],
  large: ['large', 'default', 'mid', 'small'],
}

function trimUrl(value) {
  return String(value ?? '').trim()
}

function urlFromVariants(variants, size = 'default') {
  const order = VARIANT_FALLBACKS[size] || VARIANT_FALLBACKS.default
  for (const key of order) {
    const url = trimUrl(variants?.[key])
    if (url) {
      return url
    }
  }
  return ''
}

function urlsFromImages(raw = {}, size = 'default') {
  if (!Array.isArray(raw.images) || !raw.images.length) {
    return raw?.image_url ? [raw.image_url] : []
  }
  return raw.images.map((item) => urlFromVariants(item?.variants, size)).filter(Boolean)
}

export function resolveProductImages(raw = {}, { size = 'default' } = {}) {
  const urls = urlsFromImages(raw, size)
  return urls.length ? urls : [defaultImage]
}

export function productHasRealImage(raw = {}) {
  return urlsFromImages(raw, 'mid').length > 0
}

export function resolveProductImageUrl(raw = {}, size = 'mid') {
  return resolveProductImages(raw, { size })[0]
}
